/* global ajaxData */
/* eslint-disable */
import 'slick-carousel';

export default {
  init() {
    $(document).ready(function() {
      $('.menu-toggle').on('click', function () {
        $('.header__nav-mobile').toggleClass('active');
        $('body').toggleClass('stop-scroll');
        $(this).toggleClass('burger-x');
      });

      $('.header__nav-mobile .header__menu-mobile li').on('click', function () {
        $('.header__nav-mobile').removeClass('active');
        $('.menu-toggle').removeClass('burger-x');
        $('body').removeClass('stop-scroll');
      });

      $('.consult-popup__cross').on('click', function () {
        $('.consult-popup').hide();
      });

      $('.btn, .wp-block-button__link').on('click', function (e) {
        e.preventDefault();
        $('.consult-popup').show();
      });

      $('.gfield input').on('focus', function () {
        $(this).closest('.gfield').addClass('focused-label');
      });

      $('.gfield input').on('input, change', function () {
        $(this).closest('.gfield').removeClass('focused-label');
        $(this).closest('.gfield').addClass('inputed-label');

        if(!$(this).val()) {
          $(this).closest('.gfield').removeClass('inputed-label');
          $(this).closest('.gfield').addClass('focused-label');
        }
      });

      $('.gfield input').on('focusout', function () {
        $(this).closest('.gfield').removeClass('focused-label');
      });

      $(document).on('gform_confirmation_loaded', function (event, formId) {
        if(formId == 1) {
          $('.consult-popup__inner').hide().fadeOut('slow');
          $('.success-message').css('display', 'flex').hide().fadeIn('slow');
        }
      });

      $(document).click(function(event) {
        //if you click on anything except the modal itself or the 'open modal' link, close the modal
        if (!$(event.target).closest('.btn, .wp-block-button__link, .consult-popup__inner').length) {
          $('body').find('.consult-popup').hide();
        }
      });

      $('a[href="#hero"]').addClass('active');
      const section = $('.section'),
        nav = $('.header__menu'),
        navHeight = nav.outerHeight();

      $(window).on('scroll', function () {
        const position = $(this).scrollTop();

        section.each(function () {
          const top = $(this).offset().top - navHeight - 5,
            bottom = top + $(this).outerHeight();

          if (position >= top && position <= bottom) {
            nav.find('a').removeClass('active');
            section.removeClass('active');

            $(this).addClass('active');
            nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
          } else if($(window).scrollTop() + $(window).height() == $(document).height()) {
            section.removeClass('active');
            nav.find('a').removeClass('active');
            $('.section--contacts').addClass('active');
            nav.find('a[href="#contacts"]').addClass('active');
          }
        });
      });

      $('.header__menu li a').bind("click", function(e) {
        var anchor = $(this);
        $('html, body').stop().animate({
          scrollTop: $(anchor.attr('href')).offset().top - 88
        }, 500);
        e.preventDefault();
      });

      $('.header__menu-mobile li a').bind("click", function(e) {
        var anchor = $(this);
        $('html, body').stop().animate({
          scrollTop: $(anchor.attr('href')).offset().top - 76
        }, 500);
        e.preventDefault();
      });

      $('.portfolio-slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '20px 0px 0px',
        appendDots: '.portfolio-dots',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1047,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '60px 0px 0px',
              dots: false,
              arrows: true,
              prevArrow: '[data-best-prev]',
              nextArrow: '[data-best-next]',
            },
          },
          {
            breakpoint: 1147,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '120px 0px 0px',
              dots: false,
              arrows: true,
              prevArrow: '[data-best-prev]',
              nextArrow: '[data-best-next]',
            },
          },
        ],
      });



      var imageHeight = $('.portfolio-slide__image-block').height();
      $('.portfolio-dots').css('top', imageHeight + 20 + 'px');

      $('.sponsors').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
            },
          },
        ],
      });

      $('.testimonials-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '[data-testimonials-prev]',
        nextArrow: '[data-testimonials-next]',
        dots: true,
        appendDots: '.testimonials__dots',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $('.diplomas').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        dots: true,
        appendDots: '.diplomas-wrapper__dots',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: 'unslick',
          },
        ],
      });

      $('.hiw-left-acc-box__title').on('click', function () {
        $(this).next().addClass('hide-show');
        $('.hiw-left__box').not($(this).next()).removeClass('hide-show');
      });

      $('.hiw-left__title').on('click', function () {
        $(this).parent().removeClass('hide-show');
      });

      $('.faq-left-acc-box__title').on('click', function () {
        $(this).next().addClass('hide-show');
        $('.faq-left__box').not($(this).next()).removeClass('hide-show');
      });

      $('.faq-left__title').on('click', function () {
        $(this).parent().removeClass('hide-show');
      });

      $('.tabs .tabs__title').on('click', function () {
        var desc_id = $(this).data('title');
        $(this).closest('.text-block__wrapper').find('.tabs__title').removeClass('active');
        $(this).closest('.text-block__wrapper').find('.tabs__desc').hide();
        $(this).addClass('active');
        $('.tabs .tabs__desc[data-desc="' + desc_id +'"]').show();
      });

      $('.slider').on('change', function () {
        $(this).closest('.comparison').find('.handle').css('left', $(this).val() + '%');
        $(this).closest('.comparison').find('.divisor').css('width', $(this).val() + '%');
        $(this).closest('.comparison').find('.slide-after').css('width', 100 - $(this).val() + '%' );
        if($(this).val() < 4) {
          $(this).closest('.comparison').find('.slide-before').hide();
        } else {
          $(this).closest('.comparison').find('.slide-before').show();
        }
      });

      $('.loadmore').on('click', function (event) {
        event.preventDefault()
        const $button = $(this);
        $.ajax({
          url: ajaxData.url,
          type: 'GET',
          data: {
            action: 'load_more_posts',
            offset: $button.data('offset'),
          },
          beforeSend: function () {
            $button.text('Загружаю...');
          },
        }).done(function (response) {
          const data = $.parseJSON(response);

          $button.text('Загрузить еще');
          if (data.result) {
            $('.blog-box').append($(data.result));

            $button.data('offset', $button.data('offset') + 3);
          }
        });
      });

      function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
          zoom        : $el.data('zoom') || 16,
          mapTypeId   : google.maps.MapTypeId.ROADMAP,
          styles: [
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e9e9e9"
                },
                {
                  "lightness": 17
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                },
                {
                  "lightness": 20
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#ffffff"
                },
                {
                  "lightness": 17
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#ffffff"
                },
                {
                  "lightness": 29
                },
                {
                  "weight": 0.2
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                },
                {
                  "lightness": 18
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                },
                {
                  "lightness": 16
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                },
                {
                  "lightness": 21
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dedede"
                },
                {
                  "lightness": 21
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "visibility": "on"
                },
                {
                  "color": "#ffffff"
                },
                {
                  "lightness": 16
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "saturation": 36
                },
                {
                  "color": "#333333"
                },
                {
                  "lightness": 40
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f2f2f2"
                },
                {
                  "lightness": 19
                }
              ]
            },
            {
              "featureType": "administrative",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#fefefe"
                },
                {
                  "lightness": 20
                }
              ]
            },
            {
              "featureType": "administrative",
              "elementType": "geometry.stroke",
              "stylers": [
                {
                  "color": "#fefefe"
                },
                {
                  "lightness": 17
                },
                {
                  "weight": 1.2
                }
              ]
            }
          ]
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
          initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
      }

      function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng ),
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
          position : latLng,
          map: map,
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

          // Create info window.
          var infowindow = new google.maps.InfoWindow({
            content: $marker.html(),
          });

          // Show info window when marker is clicked.
          google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
          });
        }
      }

      function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
          bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
          map.setCenter( bounds.getCenter() );

          // Case: Multiple markers.
        } else{
          map.fitBounds( bounds );
        }
      }

// Render maps on page load.
      $(document).ready(function(){
        var fired = false;
        $(window).scroll(function() {
          var hT = $('.acf-map').offset().top,
            hH = $('.acf-map').outerHeight(),
            wH = $(window).height(),
            wS = $(this).scrollTop(),
            wB = hT + hH-(wH * 3);
          if (wS > wB  && fired === false ){
            fired = true;
            $('.acf-map').each(function(){
              initMap( $(this) );
            });
          }
        });
      });

      jQuery.event.special.touchstart = {
        setup: function( _, ns, handle ){
          this.addEventListener("touchstart", handle, { passive: true });
        }
      };
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js